import { connect } from 'react-redux';
import LineCard from '../components/LineCard';
import { deleteLine } from '../actions/line';
import { removeLineFromSection, switchLineInSection } from '../actions/sections';

function parseMatch(state, match = { params: {} }) {
  const params = {
    id: parseInt(match.params.id, 10) || undefined,
    sectionIndex: parseInt(match.params.sectionIndex, 10),
    lineIndex: parseInt(match.params.lineIndex, 10),
  };

  const section = state.song.sections.byId[state.song.structure[params.sectionIndex]];

  let line;
  if (params.id) {
    line = state.song.lines.byId[params.id];
  } else if (section && params.lineIndex >= 0) {
    line = state.song.lines.byId[section.lines[params.lineIndex]];
  }

  return { ...params, section, line };
}

function getPrevLink(state, m) {
  if (m.section && m.sectionIndex >= 0 && m.lineIndex >= 0) {
    if (m.lineIndex > 0) {
      return `/song/${m.sectionIndex}/${m.lineIndex - 1}`;
    }
    const sIdx = m.sectionIndex - 1;
    while (sIdx >= 0) {
      const prevSection = state.song.sections.byId[state.song.structure[sIdx]];
      if (prevSection && prevSection.lines.length) {
        return `/song/${sIdx}/${prevSection.lines.length - 1}`;
      }
    }
  }
  return undefined;
}

function getNextLink(state, m) {
  if (m.section && m.sectionIndex >= 0 && m.lineIndex >= 0) {
    if (m.lineIndex + 1 < m.section.lines.length) {
      return `/song/${m.sectionIndex}/${m.lineIndex + 1}`;
    } else if (m.sectionIndex + 1 < state.song.structure.length) {
      return `/song/${m.sectionIndex + 1}/0`;
    }
  }
  return undefined;
}

function getPosition(state, m) {
  if (m.sectionIndex >= 0 && m.lineIndex >= 0) {
    let n = null;
    let total = 0;
    for (let s = 0; s < state.song.structure.length; s += 1) {
      const { lines } = state.song.sections.byId[state.song.structure[s]];
      if (m.sectionIndex === s) {
        n = total + m.lineIndex + 1;
      }
      total += lines.length;
    }
    return { n, total };
  }
  return undefined;
}

// function getLine(state, ownProps) {
//   const id = idFromRoute(ownProps);
//   return ownProps.line || (id ? state.song.lines.byId[id] : undefined);
// }

const mapStateToProps = (state, ownProps) => {
  if (ownProps.line) {
    return { ...ownProps, obj: ownProps.line };
  } else if (ownProps.match) {
    const m = parseMatch(state, ownProps.match);
    return {
      ...ownProps,
      ...m,
      prevLink: getPrevLink(state, m),
      nextLink: getNextLink(state, m),
      position: getPosition(state, m),
      // onSelectAlt: 'Humphrey',
    };
  }
  return ownProps;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onDelete: (ev, lineId) => {
    ev.preventDefault();
    if (lineId) {
      ownProps.history.push('/');
      dispatch(deleteLine(lineId));
    }
  },
  onRemove: (ev, sectionId, lineIndex) => {
    ev.preventDefault();
    if (sectionId && lineIndex >= 0) {
      ownProps.history.push('/');
      dispatch(removeLineFromSection(sectionId, lineIndex));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LineCard);



// WEBPACK FOOTER //
// ./src/containers/LineCardContainer.js